import {
  GET_BRANDS,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_FAIL,
  CLEAR_BRANDS,
  ADD_NEW_BRAND,
  ADD_NEW_BRAND_FAIL,
  ADD_NEW_BRAND_SUCCESS,
  UPDATE_BRAND,
  UPDATE_BRAND_FAIL,
  UPDATE_BRAND_SUCCESS,
  GET_BRAND_DETAIL,
  GET_BRAND_DETAIL_SUCCESS,
  GET_BRAND_DETAIL_FAIL,
  CLEAR_BRAND_DETAIL,
} from "./actionTypes"

export const getBrands = (options, history) => ({
  type: GET_BRANDS,
  payload: { options, history },
})

export const getBrandsSuccess = brands => ({
  type: GET_BRANDS_SUCCESS,
  payload: brands,
})

export const getBrandsFail = error => ({
  type: GET_BRANDS_FAIL,
  payload: error,
})

export const clearBrands = () => ({
  type: CLEAR_BRANDS,
})

export const addNewBrand = (data, options, history) => ({
  type: ADD_NEW_BRAND,
  payload: { data, options, history },
})

export const addNewBrandSuccess = brand => ({
  type: ADD_NEW_BRAND_SUCCESS,
  payload: brand,
})

export const addNewBrandFail = error => ({
  type: ADD_NEW_BRAND_FAIL,
  payload: error,
})

export const updateBrand = (brand, history) => ({
  type: UPDATE_BRAND,
  payload: { brand, history },
})

export const updateBrandSuccess = brand => ({
  type: UPDATE_BRAND_SUCCESS,
  payload: brand,
})

export const updateBrandFail = error => ({
  type: UPDATE_BRAND_FAIL,
  payload: error,
})

export const getBrandDetail = (options, history) => ({
  type: GET_BRAND_DETAIL,
  payload: { options, history },
})

export const getBrandDetailSuccess = brand => ({
  type: GET_BRAND_DETAIL_SUCCESS,
  payload: brand,
})
export const getBrandDetailFail = error => ({
  type: GET_BRAND_DETAIL_FAIL,
  payload: error,
})

export const clearBrandDetail = () => ({
  type: CLEAR_BRAND_DETAIL,
})
